import { Box, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { FC } from 'react';
import { copyText } from '@shared/utils/utilsOld';
import { ALLURE_REPORT_BACKGROUND_COLOR } from '@pages/testruns/constants/testrunsConstants';

interface ErrorTraceBlockProps {
    text: string;
    bgColor?: string;
}

const ErrorTraceBlock: FC<ErrorTraceBlockProps> = ({ text, bgColor = ALLURE_REPORT_BACKGROUND_COLOR['FAILED'] }) => {
    if (!text) return <></>;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'flex-start',
                backgroundColor: bgColor,
                p: '8px 16px',
            }}
        >
            <Box
                component="pre"
                sx={{
                    m: 0,
                    whiteSpace: 'pre-wrap',
                    wordBreak: 'break-word',
                    flex: 1,
                }}
            >
                {text}
            </Box>
            <IconButton onClick={() => copyText(text)}>
                <ContentCopyIcon />
            </IconButton>
        </Box>
    );
};

export default ErrorTraceBlock;
